// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep app-developer-mode {
  display: flex !important;
}

app-searchbar {
  flex: 1 1 0%;
  box-sizing: border-box;
}

.menu {
  position: relative;
  z-index: 10;
}

.search-wrapper {
  width: 42rem;
}

.version-wrapper {
  font-size: 14px;
}

.logo {
  display: flex;
  padding: 0 1.75rem 0 1rem;
}

.mobile-logo {
  display: flex;
  padding: 0 1.75rem 0 1rem;
  height: 24px;
}

.broadspire-logo,
.broadspire-logo.ie {
  --logo-desktop-display: none;
  display: var(--logo-desktop-display);
  width: 180px;
  aspect-ratio: 5/1;
}

.broadspire-logo-mobile {
  --logo-mobile-display: block;
  display: var(--logo-mobile-display);
  width: 2rem;
}

@media (min-width: 960px) {
  .broadspire-logo-mobile {
    --logo-mobile-display: none;
  }
  .broadspire-logo,
  .broadspire-logo.ie {
    --logo-desktop-display: block;
  }
}
@media screen and (max-width: 576px) {
  ::ng-deep .cdk-overlay-pane {
    position: relative;
    display: flex;
    left: 20px !important;
  }
  ::ng-deep .cdk-overlay-pane:not(.cc-advanced-search-dialog) {
    width: calc(100% - 42px) !important;
  }
}
::ng-deep #cds-content-container-quick-report {
  background-color: var(--color-ui-06) !important;
}

::ng-deep .search-form {
  background: rgb(255, 255, 255);
  position: relative;
  max-width: 800px;
}
::ng-deep .search-form input {
  font-size: 1rem;
  z-index: 2;
  cursor: text;
  border: none;
  background: transparent;
  width: calc(100% - 65px);
  outline: 0;
}
::ng-deep .search-form .material-icons {
  flex-shrink: 0;
}

::ng-deep .cds-page-header .cds-page-header-search:has(#search-mfe-container) {
  margin-right: 0px;
}

::ng-deep a.cc-advanced-search-button {
  font-weight: 500;
  line-height: 1.5rem;
}

::ng-deep .cc-advanced-search-button {
  font-family: Roboto, Tahoma, sans-serif !important;
  font-size: 14px !important;
  color: rgba(0, 0, 0, 0.87);
  margin: 5px;
  margin-right: 9px;
  display: flex;
}
::ng-deep .cc-advanced-search-button .material-icons {
  vertical-align: middle;
}

@media only screen and (max-width: 960px) {
  .cc-advanced-search-button .advanced-search-label {
    display: none;
  }
}
@media only screen and (max-width: 960px) {
  .log-out-wrapper span {
    display: none;
  }
}

.log-out-wrapper {
  display: flex;
  align-items: center;
  height: 100%;
  margin: 0 1.75rem 0 1.5rem;
  font-size: 14px;
  font-size: 14px;
  font-weight: 500;
  line-height: 1rem;
  cursor: pointer;
}

::ng-deep app-header .search-bar {
  margin: 0px;
}

::ng-deep app-header cds-select {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}
::ng-deep app-header cds-select .-open.cds-select > .cds-dropdown-toggle .cds-button,
::ng-deep app-header cds-select .-open.cds-multi-select > .cds-dropdown-toggle .cds-button {
  color: #79b700;
}
::ng-deep app-header cds-select .cds-dropdown-toggle .cds-button {
  color: white;
  box-shadow: none !important;
  font-size: 14.5px;
  font-weight: 500;
  padding: 0px 15px 0 0px !important;
  margin-top: 0px !important;
}
::ng-deep app-header cds-select .cds-dropdown-toggle .cds-button .cds-button-label {
  box-shadow: none;
  margin-left: 7px;
}
::ng-deep app-header cds-select .cds-dropdown-toggle .cds-button:hover {
  color: white;
}
::ng-deep app-header cds-select .cds-dropdown-content.-cds-position-bottom:not(.-cds-position-adjacent),
::ng-deep app-header cds-select .cds-dropdown-content.-cds-position-y-down:not(.-cds-position-adjacent) {
  background: #36363b;
  right: 100px !important;
}
::ng-deep app-header cds-select .cds-dropdown-content.-cds-position-bottom:not(.-cds-position-adjacent) .cds-radio-button-label,
::ng-deep app-header cds-select .cds-dropdown-content.-cds-position-y-down:not(.-cds-position-adjacent) .cds-radio-button-label {
  color: white;
  font-size: 14px;
  width: 170px;
}
::ng-deep app-header cds-select .cds-dropdown .cds-button > .material-icons {
  font-size: 1.5rem;
}
::ng-deep app-header cds-select .cds-radio-button-wrapper:focus-within {
  background: none !important;
}
::ng-deep app-header cds-select .cds-radio-button-wrapper:hover {
  background: #65656b !important;
}

::ng-deep app-header.apply-submenu-fix div.cds-page-header {
  min-width: min-content;
}

.log-out-wrapper,
.log-out-wrapper:active {
  margin: 0 1.75rem 0 1.5rem;
}

.log-out {
  margin: 0 0 0 8px;
}

a {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/header/header.component.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;AACF;;AAEA;EACE,YAAA;EACA,sBAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,YAAA;AACF;;AAEA;;EAEE,4BAAA;EACA,oCAAA;EACA,YAAA;EACA,iBAAA;AACF;;AAEA;EACE,4BAAA;EACA,mCAAA;EAEA,WAAA;AAAF;;AAGA;EACE;IACE,2BAAA;EAAF;EAGA;;IAEE,6BAAA;EADF;AACF;AAIA;EACE;IACE,kBAAA;IACA,aAAA;IACA,qBAAA;EAFF;EAIE;IACE,mCAAA;EAFJ;AACF;AAMA;EACE,+CAAA;AAJF;;AAOA;EACE,8BAAA;EACA,kBAAA;EACA,gBAAA;AAJF;AAME;EACE,eAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,wBAAA;EACA,UAAA;AAJJ;AAOE;EACE,cAAA;AALJ;;AASA;EACE,iBAAA;AANF;;AASA;EACE,gBAAA;EACA,mBAAA;AANF;;AASA;EACE,kDAAA;EACA,0BAAA;EACA,0BAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;AANF;AAQE;EACE,sBAAA;AANJ;;AAWA;EAEI;IACE,aAAA;EATJ;AACF;AAcE;EACE;IACE,aAAA;EAZJ;AACF;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,0BAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AAbF;;AAgBA;EACE,WAAA;AAbF;;AAgBA;EACE,2BAAA;EACA,yBAAA;EAIA,iBAAA;AAbF;AAeE;;EAEE,cAAA;AAbJ;AAiBI;EACE,YAAA;EACA,2BAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,0BAAA;AAfN;AAiBM;EACE,gBAAA;EACA,gBAAA;AAfR;AAmBI;EACE,YAAA;AAjBN;AAqBE;;EAEE,mBAAA;EACA,uBAAA;AAnBJ;AAqBI;;EACE,YAAA;EACA,eAAA;EACA,YAAA;AAlBN;AAsBE;EACE,iBAAA;AApBJ;AAuBE;EACE,2BAAA;AArBJ;AAwBE;EACE,8BAAA;AAtBJ;;AA0BA;EACE,sBAAA;AAvBF;;AA0BA;;EAEE,0BAAA;AAvBF;;AA0BA;EACE,iBAAA;AAvBF;;AA0BA;EACE,eAAA;AAvBF","sourcesContent":["::ng-deep app-developer-mode {\n  display: flex !important;\n}\n\napp-searchbar {\n  flex: 1 1 0%;\n  box-sizing: border-box;\n}\n\n.menu {\n  position: relative;\n  z-index: 10;\n}\n\n.search-wrapper {\n  width: 42rem;\n}\n\n.version-wrapper {\n  font-size: 14px;\n}\n\n.logo {\n  display: flex;\n  padding: 0 1.75rem 0 1rem;\n}\n\n.mobile-logo {\n  display: flex;\n  padding: 0 1.75rem 0 1rem;\n  height: 24px;\n}\n\n.broadspire-logo,\n.broadspire-logo.ie {\n  --logo-desktop-display: none;\n  display: var(--logo-desktop-display);\n  width: 180px;\n  aspect-ratio: 5 / 1;\n}\n\n.broadspire-logo-mobile {\n  --logo-mobile-display: block;\n  display: var(--logo-mobile-display);\n  // TODO: replace img with dark mode logo\n  width: 2rem;\n}\n\n@media (min-width: 960px) {\n  .broadspire-logo-mobile {\n    --logo-mobile-display: none;\n  }\n\n  .broadspire-logo,\n  .broadspire-logo.ie {\n    --logo-desktop-display: block;\n  }\n}\n\n@media screen and (max-width: 576px) {\n  ::ng-deep .cdk-overlay-pane {\n    position: relative;\n    display: flex;\n    left: 20px !important;\n\n    &:not(.cc-advanced-search-dialog) {\n      width: calc(100% - 42px) !important;\n    }\n  }\n}\n\n::ng-deep #cds-content-container-quick-report {\n  background-color: var(--color-ui-06) !important;\n}\n\n::ng-deep .search-form {\n  background: rgba(255, 255, 255, 1);\n  position: relative;\n  max-width: 800px;\n\n  input {\n    font-size: 1rem;\n    z-index: 2;\n    cursor: text;\n    border: none;\n    background: transparent;\n    width: calc(100% - 65px);\n    outline: 0;\n  }\n\n  .material-icons {\n    flex-shrink: 0;\n  }\n}\n\n::ng-deep .cds-page-header .cds-page-header-search:has(#search-mfe-container) {\n  margin-right: 0px;\n}\n\n::ng-deep a.cc-advanced-search-button {\n  font-weight: 500;\n  line-height: 1.5rem;\n}\n\n::ng-deep .cc-advanced-search-button {\n  font-family: Roboto, Tahoma, sans-serif !important;\n  font-size: 14px !important;\n  color: rgba(0, 0, 0, 0.87);\n  margin: 5px;\n  margin-right: 9px;\n  display: flex;\n\n  .material-icons {\n    vertical-align: middle;\n  }\n}\n\n// Hides Advanced search label\n@media only screen and (max-width: 960px) {\n  .cc-advanced-search-button {\n    .advanced-search-label {\n      display: none;\n    }\n  }\n}\n\n.log-out-wrapper {\n  @media only screen and (max-width: 960px) {\n    span {\n      display: none;\n    }\n  }\n}\n\n.log-out-wrapper {\n  display: flex;\n  align-items: center;\n  height: 100%;\n  margin: 0 1.75rem 0 1.5rem;\n  font-size: 14px;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1rem;\n  cursor: pointer;\n}\n\n::ng-deep app-header .search-bar {\n  margin: 0px;\n}\n\n::ng-deep app-header cds-select {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n\n  .-open.cds-select > .cds-dropdown-toggle .cds-button,\n  .-open.cds-multi-select > .cds-dropdown-toggle .cds-button {\n    color: #79b700;\n  }\n\n  .cds-dropdown-toggle {\n    .cds-button {\n      color: white;\n      box-shadow: none !important;\n      font-size: 14.5px;\n      font-weight: 500;\n      padding: 0px 15px 0 0px !important;\n      margin-top: 0px !important;\n\n      .cds-button-label {\n        box-shadow: none;\n        margin-left: 7px;\n      }\n    }\n\n    .cds-button:hover {\n      color: white;\n    }\n  }\n\n  .cds-dropdown-content.-cds-position-bottom:not(.-cds-position-adjacent),\n  .cds-dropdown-content.-cds-position-y-down:not(.-cds-position-adjacent) {\n    background: #36363b;\n    right: 100px !important;\n\n    .cds-radio-button-label {\n      color: white;\n      font-size: 14px;\n      width: 170px;\n    }\n  }\n\n  .cds-dropdown .cds-button > .material-icons {\n    font-size: 1.5rem;\n  }\n\n  .cds-radio-button-wrapper:focus-within {\n    background: none !important;\n  }\n\n  .cds-radio-button-wrapper:hover {\n    background: #65656b !important;\n  }\n}\n\n::ng-deep app-header.apply-submenu-fix div.cds-page-header {\n  min-width: min-content;\n}\n\n.log-out-wrapper,\n.log-out-wrapper:active {\n  margin: 0 1.75rem 0 1.5rem;\n}\n\n.log-out {\n  margin: 0 0 0 8px;\n}\n\na {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
